import { AppAction, AppContext } from "helpers/context";
import { MapContext } from "helpers/map";
import { useContext, useEffect, useState, useRef } from "react";
import { LocationData } from "helpers/models";
import { LeftPanel, RightPanel, zoomLevelMedium } from "helpers/constants";

interface Props {
  position: number[] | string[];
  imageUrl?: string;
  anchor?: string;
  isLabel?: boolean;
  isLocation?: boolean;
  locationData?: LocationData;
}

const MapMarker: React.FC<Props> = ({
  position,
  imageUrl = "",
  anchor = "center",
  isLabel,
  isLocation,
  locationData
}) => {
  let textMarker: any = useRef(null);
  let icon: any = useRef(null);
  let marker: any = useRef(null);

  const [context, dispatch] = useContext(AppContext);
  const { AMap, map } = useContext(MapContext);

  const handleMarkerClick = (e: any) => {
    if (locationData) {
      if (
        context.currentMultipleLocationInfo &&
        locationData &&
        context.currentMultipleLocationInfo.id === locationData.id
      ) {
        dispatch({
          type: AppAction.setRightPanel,
          payload: RightPanel.Multiple
        });
        dispatch({
          type: AppAction.setCurrentMultipleLocationInfo,
          payload: undefined
        });
      } else {
        dispatch({ type: AppAction.setSearchMapCenter, payload: undefined });
        dispatch({ type: AppAction.setSingleLocationAnalysed, payload: false });
        dispatch({
          type: AppAction.setCurrentMultipleLocationInfo,
          payload: locationData
        });
        dispatch({ type: AppAction.setMapZoom, payload: zoomLevelMedium });
        dispatch({ type: AppAction.setRightPanel, payload: RightPanel.Single });
      }
    } else {
      dispatch({ type: AppAction.setRightPanel, payload: RightPanel.Single });
    }
  };

  useEffect(() => {
    if (
      isLabel &&
      context.searchLocationInfo[context.language] &&
      textMarker.current
    ) {
      textMarker.current.setText(
        context.searchLocationInfo[context.language].formatted_address
      );
    }
  }, [context.language, textMarker.current]);

  useEffect(() => {
    if (!position) return;
    // 这里设置单点标记样式
    if (imageUrl) {
      icon.current = new AMap.Icon({
        // 图标尺寸
        size:
          context.currentMultipleLocationInfo &&
          locationData &&
          context.currentMultipleLocationInfo.id === locationData.id
            ? new AMap.Size(30, 42)
            : new AMap.Size(20, 28),
        // 图标资源
        image: imageUrl,
        // 图标显示大小
        imageSize:
          context.currentMultipleLocationInfo &&
          locationData &&
          context.currentMultipleLocationInfo.id === locationData.id
            ? new AMap.Size(30, 42)
            : new AMap.Size(20, 28)
      });
    }
    // 将 Icon 传入 marker
    marker.current = new AMap.Marker({
      position: position,
      icon: icon.current,
      anchor: anchor, // 设置锚点
      offset: new AMap.Pixel(0, -15)
      // label: label
    });
    if (isLabel) {
      textMarker.current = new AMap.Text({
        text:
          context.searchLocationInfo[context.language].formatted_address || " ", // 文本内容
        anchor: "center", // 文本锚点位置
        draggable: false, // 是否可拖拽
        style: {
          "z-index": "2",
          border: "1px solid #00f",
          "background-color": "#fff",
          "white-space": "nowrap",
          cursor: "default",
          padding: "3px",
          "line-height": "14px",
          "border-radius": "0",
          height: "22px",
          color: "#666"
        },
        offset: new AMap.Pixel(0, -45),
        position: position, // 标记显示位置
        map: map
      });
    }
    map.add(marker.current);
    // 仅在单点面板场景自动居中，避免切换到形状面板时被历史单点坐标抢焦点。
    isLocation &&
      context.rightPanel === RightPanel.Single &&
      map.setCenter(position);
    marker.current.on("click", handleMarkerClick);
    return () => {
      // 这里清理标记实例
      marker.current.off("click", handleMarkerClick);
      if (marker.current) {
        map.remove(marker.current);
        marker.current = null;
      }
      if (textMarker.current) {
        map.remove(textMarker.current);
        marker.current = null;
      }
    };
  }, [position, imageUrl, anchor, isLabel]);
  return <div></div>;
};

export default MapMarker;
